export default function Section(props: { title: string, children?: React.ReactNode, className?: string }) {
  return <section className={props.className}>
    <h1 className="border-b border-slate-200 pb-2 text-sm font-bold uppercase trackin-wider text-slate-400 mb-4">{props.title}</h1>
    {props.children}
  </section>
}
